
import React from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App.tsx'
import './index.css'
import { AuthProvider } from '@/context/AuthContext'
import { Toaster } from 'sonner'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'

// Create a client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      refetchOnWindowFocus: false,
    },
  },
});

// Add cache-busting version parameter
const appVersion = `${import.meta.env.VITE_APP_VERSION || new Date().getTime()}`;
console.log(`App version: ${appVersion}`);

// Ensure the script is loaded with a cache-busting query parameter
const currentScript = document.currentScript as HTMLScriptElement;
if (currentScript && currentScript.src && !currentScript.src.includes('?v=')) {
  const url = new URL(currentScript.src);
  url.searchParams.set('v', appVersion);
  
  // Only log in development for debugging
  if (import.meta.env.DEV) {
    console.log(`Cache-busted script URL: ${url.toString()}`);
  }
}

createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <App key={appVersion} />
          <Toaster position="top-right" />
        </AuthProvider>
      </QueryClientProvider>
    </BrowserRouter>
  </React.StrictMode>
);
